import React from 'react';
import teacher from '../images/teacher.png';
import calender from '../images/calender.png';
import interactive from '../images/interactive.png';
import project from '../images/project.png';

export default function Whyonlinepaathshala() {
  return (
   <>
   

  
   <div>
    <p className='text-2xl mt-4 mb-4 font-bold text-cuscolor-light justify-center flex '><span className='text-cuscolor'>Why Online&nbsp; &nbsp; </span> पाठशाला</p>
   </div>

<div className='flex flex-col gap-4 md:flex-row items-center justify-center container mx-auto  mb-[35px]'>


   <div className=' h-auto w-[300px] shadow flex p-4 flex-col justify-center items-center  '>
    <div>
        <img src={teacher}alt="teacher onlinepaathshala" className='h-10 w-15' />
    </div>
    <div>
        <p className='text-cuscolor-light font-semibold text-xl mt-2'>Qualified Teacher</p>
    </div>
    <div className='flex justify-center mt-3'>
        <p className='text-cuscolor text-center'>Our teacher are qualified Engineers. <br></br> They have experience of working in wellfamous industries </p>
    </div>
   </div>

   <div className=' h-auto w-[300px] shadow flex p-4 flex-col justify-center items-center  '>
    <div>
        <img src={calender}alt="teacher onlinepaathshala" className='h-10 w-15' />
    </div>
    <div>
        <p className='text-cuscolor-light font-semibold text-xl mt-2'>Flexible Timing</p>
    </div>
    <div className='flex justify-center mt-3'>
        <p className='text-cuscolor text-center'>Our teacher are qualified Engineers. <br></br> They have experience of working in wellfamous industries </p>
    </div>
   </div>

   <div className=' h-auto w-[300px] shadow flex p-4 flex-col justify-center items-center  '>
    <div>
        <img src={project}alt="teacher onlinepaathshala" className='h-10 w-15' />
    </div>
    <div>
        <p className='text-cuscolor-light font-semibold text-xl mt-2'>Project</p>
    </div>
    <div className='flex justify-center mt-3'>
        <p className='text-cuscolor text-center'>Our teacher are qualified Engineers. <br></br> They have experience of working in wellfamous industries </p>
    </div>
   </div>

   <div className=' h-auto w-[300px] shadow flex p-4 flex-col justify-center items-center  '>
    <div>
        <img src={interactive}alt="teacher onlinepaathshala" className='h-10 w-15' />
    </div>
    <div>
        <p className='text-cuscolor-light font-semibold text-xl mt-2'>Interactive Classes</p>
    </div>
    <div className='flex justify-center mt-3'>
        <p className='text-cuscolor text-center'>Our teacher are qualified Engineers. <br></br> They have experience of working in wellfamous industries </p>
    </div>
   </div>
   </div>
   
   </>
  )
}
